import { searchValidations } from '../../../helpers/profileGeneratorHelper';

export async function includeValidation(
  componentPath: string,
  entityName: string,
): Promise<{
  filePaths: string[];
  associations: {
    taskId: string;
    pullerId: string;
    tableId: string;
    resultKey: string;
  } | null;
} | null> {
  const validations = (await searchValidations(
    entityName,
    componentPath,
  )) as any[];

  if (!validations.length) {
    console.error(
      `Could not find validation named ${entityName} in ${componentPath}`,
    );
    return null;
  }

  const filePaths = validations
    .map((v) => v.__file_path)
    .filter(Boolean)
    .filter((v, i, a) => a.indexOf(v) === i);

  return { filePaths, associations: null };
}
